import { KeyName, KeyNameId } from '../types/common';

/** Stammdaten (id-carrying entities like Hauptgruppe or Steuer) render as
    "key — name", like the customer panel — the id marks a masterdata record,
    so the key belongs into the display. A missing half falls back to the
    other; nothing at all renders as '—'. */
export function masterdataLabel(v: Partial<KeyNameId> | null | undefined): string {
  const key = v?.key?.trim();
  const name = v?.name?.trim();
  if (key && name) return `${key} — ${name}`;
  return name || key || '—';
}

/** Kennzeichen ({key, name} without id) render by their name — the backend
    delivers the translated SoftTOP label there (handoff 451419); a backend
    without the label echoes the key in name, older ones only send key. */
export function flagLabel(v: Partial<KeyName> | null | undefined): string {
  return v?.name?.trim() || v?.key?.trim() || '—';
}
